import styled, { css } from 'styled-components';
import { ReactComponent as IconLoading } from '@whitelabel/media/icons/loading.svg';
import { themeColor } from '@whitelabel/helpers/style/colors';
import { spacer, multiply } from '@whitelabel/helpers/style/units';

export const StyledLoading = styled.div<{ $height?: string }>`
  height: ${({ $height }) => $height || '100vh'};

  /* In case of full height */
  ${({ $height }) =>
    (typeof $height === 'undefined' || $height === '100vh') &&
    css`
      z-index: 10000;
      top: 0;
      position: fixed;
      width: 100vw;
      background: white;
    `}

  display: flex;
  align-items: center;
  align-self: center;
  justify-content: center;
  justify-self: center;
`;

export const StyledIcon = styled(IconLoading)`
  display: block;
  width: ${multiply(spacer, 3.375)};
  height: ${multiply(spacer, 4)};
  color: ${themeColor('primary')};
`;
